module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "toast-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.showMessage) ? _c('div', {
    staticClass: "notification is-warning"
  }, [_vm._v("\n        " + _vm._s(_vm.toastMessage) + "\n      ")]) : _vm._e()])], 1), _vm._v(" "), _c('form', {
    staticClass: "form-group",
    attrs: {
      "id": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addRating($event)
      }
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editName),
      expression: "editName"
    }],
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateData.name),
      expression: "rateData.name"
    }],
    staticClass: "input is-medium input-name",
    attrs: {
      "type": "text",
      "placeholder": "Vad är ditt namn?",
      "id": "editName",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.rateData.name)
    },
    on: {
      "blur": _vm.toggleEditName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rateData, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editName),
      expression: "!editName"
    }],
    staticClass: "control has-text-centered"
  }, [_c('label', {
    staticClass: "rater-name",
    attrs: {
      "for": "editName"
    },
    on: {
      "click": _vm.toggleEditName
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.rateData.name))]), _vm._v(", snart dags för öl!\n        "), _c('i', {
    staticClass: "fa fa-edit"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select is-medium"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateData.beer),
      expression: "rateData.beer"
    }],
    staticClass: "select-beer",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rateData, "beer", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Välj en öl ...")]), _vm._v(" "), _vm._l((_vm.beers), function(beer) {
    return _c('option', {
      domProps: {
        "value": beer.id
      }
    }, [_vm._v(_vm._s(beer.name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "range-wrapper"
  }, [_c('range-slider', {
    staticClass: "range-input",
    attrs: {
      "min": "0",
      "max": "20",
      "step": "1"
    },
    model: {
      value: (_vm.sliderValue),
      callback: function($$v) {
        _vm.sliderValue = $$v
      },
      expression: "sliderValue"
    }
  }), _vm._v(" "), _c('output', {
    staticClass: "range-output",
    attrs: {
      "id": "rangeInfo"
    },
    domProps: {
      "textContent": _vm._s(_vm.total)
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "control"
  }), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-primary is-large",
    attrs: {
      "type": "submit",
      "disabled": !_vm.isValid,
      "value": "Sätt betyget ..."
    },
    on: {
      "click": _vm.flashMessage
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "latest-beers"
  }, _vm._l((_vm.bestBeers), function(beer) {
    return _c('li', {
      staticClass: "beer-item"
    }, [_c('span', {
      staticClass: "average"
    }, [_vm._v(_vm._s(beer.average))]), _vm._v(" - " + _vm._s(beer.name))])
  }))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0af5aff8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0af5aff8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Rating.vue
// module id = 148
// module chunks = 1